import * as React from 'react';
import { Button, Responsive } from '@cian/ui-kit';

import * as styles from './styles.css';
import { TButtonTheme } from '@cian/ui-kit/button/types';

export interface IAboutRealtorFooterProps {
  buttonText: string;
  buttonTheme: TButtonTheme;
  onButtonClick: () => void;
  isButtonDisabled?: boolean;
}

export const AboutRealtorFooter: React.FC<React.PropsWithChildren<IAboutRealtorFooterProps>> = props => {
  const { buttonText, buttonTheme, onButtonClick, isButtonDisabled } = props;

  return (
    <div className={styles['footer']}>
      <Responsive desktop>
        <div className={styles['button-wrapper']}>
          <Button theme={buttonTheme} size="XS" disabled={isButtonDisabled} onClick={onButtonClick}>
            {buttonText}
          </Button>
        </div>
      </Responsive>
      <Responsive phone tablet>
        <Button fullWidth theme={buttonTheme} size="M" disabled={isButtonDisabled} onClick={onButtonClick}>
          {buttonText}
        </Button>
      </Responsive>
    </div>
  );
};

AboutRealtorFooter.displayName = 'AboutRealtorFooter';
